module.exports = __webpack_public_path__ + "static/media/logo_inmet.fdebb9d7.png";